module.exports = __webpack_public_path__ + "images/visame-82db0b90.png";